module.exports = __webpack_public_path__ + "media/images/update-34a1870a98156f27d1335b00e283f416.svg";